export type ApiSpec = {
  name: string;
  title: string;
  definitionPacked: string;
};

export type ApiPortalDoc = {
  id: string;
  title: string;
  summary: string;
  reference: string;
};

export type ApiPortalCategory = {
  name: string;
  id: string;
  description: string;
  logo: string;
  apiSpecsPaged: {
    specs: ApiSpec[];
    totalCount: number;
  };
  apiEventsPaged: {
    events: ApiPortalDoc[];
    totalCount: number;
  };
  apiScenariosPaged: {
    scenarios: ApiPortalDoc[];
    totalCount: number;
  };
};

export type ApiPortalOrg = {
  name: string;
  _normalizedName: string;
  categoriesPaged: {
    categories: ApiPortalCategory[];
    totalCount: number;
  };
  totalCount: number;
};

export type ApiPortalData = {
  devhub: {
    apiPortal: {
      apiPortalOrgsPaged: {
        orgs: ApiPortalOrg[];
      };
    };
  };
};

export enum DocType {
  Scenario = 'scenarios',
  Event = 'events',
}
